import { formatNumber } from "accounting"

import Private from "../../../Components/Private"
import { sortableTitle } from "./sortableTitle"

const num = (v) => <Private>{formatNumber(v ?? 0, 0, ",")}</Private>
const pct = (v) => (v == null ? "-" : <Private>{`${Math.round(v)}%`}</Private>)
const money = (v) => <Private>{`$${formatNumber(v ?? 0, 2, ",")}`}</Private>

// One by-channel/ column, sorted locally: the answer holds every channel.
const column = (t, label, key, render, width = 140) => ({
  title: sortableTitle(t(label), key, { align: "right" }),
  dataIndex: key,
  key,
  width,
  align: "right",
  sorter: (a, b) => (a[key] ?? -1) - (b[key] ?? -1),
  render
})

const channelColumn = (t) => ({
  title: sortableTitle(t("Channel"), "label"),
  dataIndex: "label",
  key: "label",
  sorter: (a, b) => a.label.localeCompare(b.label),
  render: (label) => t(label)
})

// The Match rate page table: how each channel converts inquiries into matched orders.
export const matchRateColumns = (t) => [
  channelColumn(t),
  column(t, "Match rate", "match_rate", pct),
  column(t, "Matched", "matched_count", num),
  { ...column(t, "Lookups", "lookups_count", num), defaultSortOrder: "descend" },
  column(t, "Volume ($)", "fees_amount", money, 150),
  column(t, "Order value ($)", "order_amount", money, 170)
]

// The figure columns take 740px; the rest is room for the channel. Below it the table scrolls
// instead of wrapping the channel a letter per line.
export const MATCH_RATE_TABLE_SCROLL = { x: 870 }

export const MATCH_RATE_SUMMARY_CELLS = [
  { align: "right", render: (s) => pct(s.match_rate) },
  { align: "right", render: (s) => num(s.matched_count) },
  { align: "right", render: (s) => num(s.lookups_count) },
  { align: "right", render: (s) => money(s.fees_amount) },
  { align: "right", render: (s) => money(s.order_amount) }
]

// The Channels page table: what each channel costs and how much of the traffic it carries.
export const channelBreakdownColumns = (t) => [
  channelColumn(t),
  // unit_fee is null when the account's pricing cannot be read.
  column(t, "Unit volume", "unit_fee", (v) => (v == null ? "-" : money(v)), 130),
  { ...column(t, "Lookups", "lookups_count", num), defaultSortOrder: "descend" },
  column(t, "Matched", "matched_count", num),
  column(t, "Match rate", "match_rate", pct),
  column(t, "Volume ($)", "fees_amount", money, 150),
  column(
    t,
    "Share",
    "share",
    (v) => <Private>{`${formatNumber(v ?? 0, 1, ",", ".")}%`}</Private>,
    110
  )
]

// The figure columns take 810px; the rest is room for the channel, as on the Match rate table.
export const CHANNEL_TABLE_SCROLL = { x: 940 }

export const CHANNEL_SUMMARY_CELLS = [
  null,
  { align: "right", render: (s) => num(s.lookups_count) },
  { align: "right", render: (s) => num(s.matched_count) },
  { align: "right", render: (s) => pct(s.match_rate) },
  { align: "right", render: (s) => money(s.fees_amount) },
  null
]
